import { JSX } from 'react';
import Spinner from '@rio-cloud/rio-uikit/Spinner';

export const LoadingIndicator = (): JSX.Element => (
    <div className={'display-flex justify-content-center'}>
        <Spinner />
    </div>
);
